import { EYE_REPAIR_V32 } from "@/data/eyeRepairV32";

// PDP3.3 — exact duplicate of PDP3.2. Keeps `v32: true` so all v32 layout/
// behaviour/colour scoping carries over identically; the extra `v33` flag is
// only a marker for its own scope class / route.
export const EYE_REPAIR_V33 = {
  ...EYE_REPAIR_V32,
  v33: true,
  collage: {
    ...EYE_REPAIR_V32.collage,
    topImage:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_76fde4e1-b224-41fa-b1e0-b502822df34b/artifacts/32jqa6ea_Image%20Sep%2019%2C%202026%2C%2002_40_36%20AM%20%281%29.png",
    topAlt: "Eye Repair Treatment foam texture",
  },
};

export default EYE_REPAIR_V33;
